import React from 'react';
import { aboutData } from '../data';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';

const About = () => {
  const { title, subtitle1, subtitle2 } = aboutData;

  return (
    <section className="lg:py-10 xl:pb-20">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row gap-x-10 items-center">
          {/* Number and Decorative Background */}
          <motion.div
            variants={fadeIn('right')}
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: false, amount: 0.7 }}
            className="flex-1"
          >
            {/* // md:text-[460px] */}
            <div
              className="text-[200px]  xl:text-[520px] leading-none font-tertiary 
              lg:-tracking-[0.055em] bg-about bg-no-repeat bg-right bg-clip-text text-transparent"
            >
              01
            </div>
          </motion.div>

          {/* Text Content */}
          <motion.div
            variants={fadeIn('left')}
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: false, amount: 0.6 }}
            className="flex-1 h-full xl:mt-0"
          >
            <h2 className="h2">{title}</h2>
            <div className="flex flex-col items-start">
              <div className="max-w-[600px] text-grey">
                <p className="mb-4">{subtitle1}</p>
                <p className="mb-6">{subtitle2}</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;